import Vue from 'vue';
import axios from 'axios';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element';
import '@/assets/theme/linearicons.css';
import VueResponsiveProvide from 'vue-provide-responsive';
import VueObserveVisibility from 'vue-observe-visibility';
import * as filters from '../src/utils/filters';

Vue.use(VueObserveVisibility);
Vue.use(VueResponsiveProvide, {
	breakpoints: {
		mobile: 768,
		// will be converted to responsive.isMobile helper (works exactly like a computed)
		// will be true if the viewport width is less or equals 768 pixels
	},
});
Vue.config.productionTip = false;

const token = localStorage.getItem('accessToken');
if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;

Vue.use(VueLodash, { lodash: lodash });

Vue.prototype.$axios = axios;
Vue.prototype.$checkCurrentRouteAndRedirect = function (router, path) {
	const {
		currentRoute: { path: curPath },
	} = router;
	if (curPath !== path) router.push({ path });
};
Vue.filter('toCurrency', (value, currency) => {
	if (typeof value !== 'number') return value;

	var formatter = new Intl.NumberFormat('es-AR', {
		style: 'decimal',
		minimumFractionDigits: 2,
	});

	return formatter.format(value);
});
Vue.filter('dateFormat', date => {
	if (date) {
		var dateParts = date.split('-');
		return dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
	}
});
//Soluciona todos los problemas de responsive en los componentes
Vue.mixin({
	computed: {
		// no uses arrow function aquí, necesitamos el this de Vue
		responsive() {
			// @ts-ignore: lo tipamos bien en el .d.ts
			return this.$responsive;
		},
	},
});
Vue.prototype.$filters = filters; // inyecta helpers

// (opcional) mantener también el filtro clásico por compatibilidad:
Vue.filter('capitalize', filters.capitalize);

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
